import './style.css';

const createUpdateSpinner = () => {    
    const div1 = document.createElement('div');
    const div2 = document.createElement('div');
    const spinner = document.createElement('div');
    spinner.classList.add('lds-ripple');
    spinner.appendChild(div1);
    spinner.appendChild(div2);
    const title = document.createElement('h5');
    title.classList = "fw-italic fw-bold";
    title.innerText = "Atualizando PsicoApp, aguarde...";    
    const logoImage = document.createElement('img');    
    logoImage.src = "img/logo-psicoapp-desenho.png";
    logoImage.style.width = "4rem";
    logoImage.style.height = "4rem";
    const container = document.createElement('div');
    container.classList= 'd-flex flex-column justify-content-center align-items-center p-4 bg-white w-90 h-40 rounded';    
    container.appendChild(logoImage);
    container.appendChild(spinner);
    container.appendChild(title);
    const spinnerWrapper = document.createElement('div');
    spinnerWrapper.id = "updateSpinner";
    spinnerWrapper.classList.add('spin-wrapper');
    spinnerWrapper.appendChild(container);    
    const body = document.querySelector('body');
    body.appendChild(spinnerWrapper);
}

const removeUpdateSpinner = () => {
    const spinner = document.getElementById('updateSpinner');
    spinner.remove();
}

export { createUpdateSpinner, removeUpdateSpinner };
